import { DateTime } from 'luxon';
import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { ContentContainer } from 'common/components/cookbook/ContentContainer';
import { Stack } from 'common/components/cookbook/Stack';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useUserLanguage } from 'common/hooks/useUserLanguage';

const Subheading = styled(T.bodyLabel)`
  color: ${color.textSubdued};
`;

type Props = {
  deliveryDate: string;
  totalUnits: number;
  totalPos: number;
};

export const InboundLoadDateHeader = ({ deliveryDate, totalUnits, totalPos }: Props) => {
  const f = useFormatMessage();
  const language = useUserLanguage();

  const inboundDate = DateTime.fromISO(deliveryDate);
  const isPast = inboundDate.startOf('day') < DateTime.now().startOf('day');
  const isToday = inboundDate.hasSame(DateTime.now(), 'day');

  const month = inboundDate.toLocaleString({ month: 'long' }, { locale: language });
  const { day } = inboundDate;

  return (
    <ContentContainer borderBottom verticalPadding="sm">
      <Stack direction="column" gap="narrowSmall">
        <T.Heading variant="headline" level={2}>
          {isToday
            ? f('receiving.purchase_order_today')
            : f(isPast ? 'receiving.purchase_order_past' : 'receiving.purchase_order_future', {
                month,
                day,
              })}
        </T.Heading>
        <Subheading>
          {totalPos} {f('common.po_plural', { poCount: totalPos })} {' · '}
          {totalUnits} {f('common.unit_plural', { unitCount: totalUnits })}
        </Subheading>
      </Stack>
    </ContentContainer>
  );
};
